import { getCookie, removeCookie, setCookie } from "../cookies/cookies";
import { getUTCDate } from "../getUTCDate/getUTCDate";

export const PASS_VERIFIED_DATE_OF_BIRTH_COOKIE = "passVerifiedDateOfBirth" as const;
export const PASS_VERIFIED_PHONE_COOKIE = "passVerifiedPhone" as const;
export const PASS_VERIFIED_NAME = "passVerifiedName" as const;

export const PASS_VERIFIED_DATA = [
  PASS_VERIFIED_NAME,
  PASS_VERIFIED_PHONE_COOKIE,
  PASS_VERIFIED_DATE_OF_BIRTH_COOKIE,
] as const;
export type PassVerifiedData = (typeof PASS_VERIFIED_DATA)[number];

export const getPassVerifiedData = (key: PassVerifiedData) => getCookie(key);

export const setPassVerifiedData = (data: string, key: PassVerifiedData, ttlInSeconds: number = 24 * 60 * 60) => {
  const ttlInMs = ttlInSeconds * 1000;
  const ttlOfPassAgeVerification = getUTCDate(ttlInMs);
  setCookie(key, data, "/", ttlOfPassAgeVerification);
};

export const deletePassVerifiedData = (key: PassVerifiedData) => {
  removeCookie(key);
};

export const deleteAllPassUserData = () => {
  PASS_VERIFIED_DATA.forEach((key) => {
    removeCookie(key);
  });
};
